import './style.css';
// Фиксированная навигация
jQuery(window).on('mousewheel DOMMouseScroll MozMousePixelScroll', function (event) {
    var $pagination = jQuery('.bx-pagination'),
        scroll_curent = jQuery(window).scrollTop(),
        windowHeight = jQuery(window).height();
    if (typeof $pagination == 'undefined'
        || !$pagination.length
        || $pagination.offset() == undefined
        || typeof $header == 'undefined'
        || !$header.length
        || $header.offset() == undefined
    ) {
        return true;
    }
    var scroll_to_pagination = $pagination.offset().top, // проверка на докрутку до самой пагинации
        scroll_to_header = $header.offset().top;
    //если мы докрутили до нужного элемента
    $small_cart = jQuery(".bx-basket-fixed.bottom").outerHeight(true) || 0;
    if (scroll_curent > scroll_to_header && scroll_curent < (scroll_to_pagination - window.innerHeight)) {
        $pagination.addClass("fixed").find(".bx-pagination-container").css("bottom", $small_cart);
    } else {
        $pagination.removeClass("fixed").find(".bx-pagination-container").css("bottom", $small_cart);
    }
    var delta = parseInt(event.originalEvent.wheelDelta || -event.originalEvent.detail);
    // TODO При скролле наверх менять индикацию страниц
    // https://ra-germes.bitrix24.ru/workgroups/group/96/tasks/task/view/1978/
    if (delta != 0) {
        var result = [],
            scroll_bottom = scroll_curent + windowHeight;
        section_key_class = 'section-page-';
        jQuery(".catalog-section div[class*='" + section_key_class + "']:visible").each(function () {
            var $el = jQuery(this),
                item = $el.offset();
            item.bottom = $el.height() + item.top;
            var page_index = $el.data('page');
            if (
                page_index != undefined && page_index != 0 &&
                (
                    item.top <= scroll_curent && item.bottom > scroll_curent ||
                    item.top > scroll_bottom && item.top < scroll_curent
                )
            ) {
                var cur_page;
                if (cur_page = $pagination.find("li[data-page='" + page_index + "']")) {
                    $pagination.find("li").removeClass('bx-active');
                    cur_page.addClass('bx-active');
                }
                // console.log("Раздел "+page_index);
            }
        });
    }
});
// "СКРОЛЛ К СТРАНИЦЕ"
export function scrollToPage(number) {
    // check page in dom
    let sectionPageNumberNode = BX("catalog-page-number-" + number);
    if (BX.type.isDomNode(sectionPageNumberNode)) {
        let sectionPageNumberNodeList = BX.findChildren(BX('catalog-section'), { class: 'catalog-page-number' }, true);
        for (const i in sectionPageNumberNodeList) {
            if (Object.hasOwnProperty.call(sectionPageNumberNodeList, i)) {
                sectionPageNumberNodeList[i].classList.remove("d-none");
            }
        }
        sectionPageNumberNode.scrollIntoView({ block: "center", behavior: "smooth" });
        return true
    }
    return false
}

jQuery(document).on("click", ".bx-pagination a[href]", function (event) {
    // event.stopPropagation();
    event.preventDefault();
    return !scrollToPage(parseInt(jQuery(this).text()));
});
export function showPageByNumber(number: Integer, max_page: Integer) {
    if (parseInt(number) > parseInt(max_page)) number = max_page;
    if ((!isNaN(parseInt(number)) && isFinite(number))
        && confirm("Уверены что хотите перейти на страницу " + number)
    ) {
        const url = new URL(window.location.href);
        url.searchParams.set('PAGEN_1', number);
        window.location.href = url.toString();
    }
}
export function scrollToTarget(target) {
    const duration = 800;
    const top = target.getBoundingClientRect().top;
    const startPos = window.pageYOffset;
    const diff = top;

    let startTime = null;
    let requestId;

    const loop = function (currentTime) {
        if (!startTime) {
            startTime = currentTime;
        }

        // Elapsed time in miliseconds
        const time = currentTime - startTime;

        const percent = Math.min(time / duration, 1);
        window.scrollTo(0, startPos + diff * percent);

        if (time < duration) {
            // Continue moving
            requestId = window.requestAnimationFrame(loop);
        } else {
            window.cancelAnimationFrame(requestId);
        }
    };
    requestId = window.requestAnimationFrame(loop);
};
